import { Pipe, PipeTransform } from '@angular/core';
import { Automobilia, SaleStatus } from '../models/automobilia.model';

@Pipe({
  name: 'automobiliaSaleStatusFilter'
})
export class AutomobiliaSaleStatusFilterPipe implements PipeTransform {

  transform(automobilias: Automobilia[], saleStatus: SaleStatus): any {
    if (!automobilias || !saleStatus) {
      return automobilias;
    }
    return automobilias.filter(automobilia => automobilia.saleStatus === saleStatus);
  }

}
